<template>
  <div class="mockup-preview-video">
    <slot name="stores"></slot>

    <div class="mockup__input">
      <label class="mockup__btn" :for="`previewVideo${timestamp}`"
        >Upload Video</label
      >
      <input
        type="file"
        v-show="false"
        :id="`previewVideo${timestamp}`"
        ref="previewVideo"
        @change="setPreviewVideo"
        accept=".mp4"
      />
    </div>
    <preview-video :current="current.previewVideo" />
  </div>
</template>

<script>
import PreviewVideo from "./preview-video/PreviewVideo.vue";

export default {
  components: { PreviewVideo },
  props: { current: Object },
  data() {
    return {
      timestamp: new Date().getTime(),
    };
  },
  methods: {
    videoIsSquare(url) {
      return new Promise((resolve) => {
        let video = document.createElement("video");
        video.addEventListener(
          "loadedmetadata",
          () => resolve(video.videoWidth === video.videoHeight),
          false
        );
        video.src = url;
      });
    },
    setPreviewVideo() {
      const file = this.$refs.previewVideo.files[0];
      if (!file) return;
      this.current.addPreviewVideo({ file });
      // const _URL = window.URL || window.webkitURL;
      // this.videoIsSquare(_URL.createObjectURL(file)).then((isSquare) => {
      //   if (isSquare) this.current.addPreviewVideo({ file });
      //   else alert("Só trabalhamos com vídeos quadradas, tente novamente!");
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.mockup-preview-video {
  display: grid;
  padding: 0 6px 6px;
  gap: 6px;
}
</style>
